<template lang="pug">
  #ReservationIndex
    h5.text-center.pt-2 我的預約
    b-row(
      no-gutters
      class="mb-3 px-2 button-row"
    )
      b-col(
        cols=3
      )
        b-button.button-first(
          block,
          :variant=" nowSelect === '已預約' ? 'primary' : 'outline-primary' ",
          @click="changeStatusHandler('已預約')"
        ) 已預約
      b-col(
        cols=3
      )
        b-button(
          block,
          :variant=" nowSelect === '確認中' ? 'primary' : 'outline-primary' ",
          @click="changeStatusHandler('確認中')"
        ) 確認中
      b-col(
        cols=3
      )
        b-button(
          block,
          :variant=" nowSelect === '預約完成' ? 'primary' : 'outline-primary' ",
          @click="changeStatusHandler('預約完成')"
        ) 預約完成
      b-col(
        cols=3
      )
        b-button.button-last(
          block,
          :variant=" nowSelect === '已過期' ? 'primary' : 'outline-primary' ",
          @click="changeStatusHandler('已過期')"
        ) 已過期
    .px-3
      b-card.border-0.mb-2.customerCard.overflow-hidden(
        bg-variant="light",
        v-for="(reservation,index) in filterReservationList",
        :key="reservation.id"
      )
        .row.align-items-center.border-bottom.pb-3.mb-3.no-gutters
          .col-6.pr-1
            ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
              :profileUrl="reservation.img",
              :style="{ 'width': '80px', 'height': '80px' }"
            )
          .col-6.pl-1
            p.mb-0.font-weight-bold 暱稱名 {{ reservation.name }}
            p.mb-0 備註名 {{ reservation.nick_name }}
        .reserveAtRow.mb-2.d-flex.align-items-center
          i.far.fa-calendar-check.mr-2
          small 預約時間：{{ reservation.reserve_at }}
        .typeRow.mb-2.d-flex.align-items-center
          i.fas.fa-border-all.mr-2
          small 服務內容：{{ reservation.reserve_name }}
        .statusRow.mb-2.d-flex.align-items-center
          i.far.fa-check-circle.mr-2
          small 預約狀態：{{ reservation.status === 0 ? '已預約' : reservation.status === 1 ? '確認中' : reservation.status === 2 ? '預約完成' : reservation.status === 3 ? '已過期' : '-' }}
        .labelRow.d-flex.align-items-center.flex-wrap.mb-3
          i.fas.fa-tag.mr-2
          small 顧客標籤：
          b-badge.m-1.rounded-50.px-3.py-2(
            variant="primary",
            v-for="label in reservation.labels"
            :key="label.id"
          ) {{ label.label }}
        b-row(
          no-gutters
        )
          b-col(
            cols=6,
            class="d-flex justify-content-end pr-1",
            v-if="reservation.status === 0 || reservation.status === 1"
          )
            b-button(
              size="sm",
              variant="primary",
              @click="cancelReservationHandler(reservation.id)"
            ) 取消預約
          b-col(
            cols=6,
            class="pl-1",
            v-if="reservation.status === 0"
          )
            b-button(
              size="sm",
              variant="primary",
              @click="editReservationHandler(reservation.id)"
            ) 修改預約
          b-col(
            cols=6,
            class="pl-1",
            v-if="reservation.status === 1"
          )
            b-button(
              size="sm",
              variant="primary",
              @click="confirmReservationHandler(reservation.id)"
            ) 預約確認
        .labelTag(
          v-if="reservation.status === 3",
          style="right: 0;bottom: 0;"
        )
          span.labelTag__text 已過期
</template>

<script>
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import { SM_RESERVATION_EDIT } from '@/router/sm/reservation';

// 測試圖片
import userExOneUrl from '@/assets/images/example/sa_1.png';
import userExTwoUrl from '@/assets/images/example/sa_2.png';
import userExThreeUrl from '@/assets/images/default/defaultImg.png';

export default {
  name: 'ReservationIndex',
  components: {
    ProfilePhotoSticker
  },
  data() {
    return {
      nowSelect: '已預約',
      reservationList: [
        {
          id: 0,
          name: 'Patty',
          nick_name: '小白兔',
          img: userExOneUrl,
          reserve_at: '2020/06/29 18:30',
          reserve_name: '產品諮詢',
          status: 0,
          labels: [
            {
              id: 0,
              label: '美白'
            },
            {
              id: 1,
              label: 'VIP'
            }
          ]
        },
        {
          id: 1,
          name: 'LuLu',
          nick_name: '超想白大戶',
          img: userExTwoUrl,
          reserve_at: '2020/06/25 11:30',
          reserve_name: '產品諮詢',
          status: 1,
          labels: [
            {
              id: 1,
              label: 'VIP'
            }
          ]
        },
        {
          id: 2,
          name: 'Ariby',
          nick_name: '中實戶',
          img: userExThreeUrl,
          reserve_at: '2020/02/12 08:00',
          reserve_name: '客訴',
          status: 3,
          labels: [
            {
              id: 1,
              label: '難搞客戶'
            }
          ]
        }
      ]
    };
  },
  mounted() {
    this.$store.commit('toggleLoading', false);
  },
  methods: {
    changeStatusHandler(type) {
      const vm = this;
      switch (type) {
        case '已預約':
          if (vm.nowSelect === '已預約') return;
          vm.nowSelect = '已預約';
          break;
        case '確認中':
          if (vm.nowSelect === '確認中') return;
          vm.nowSelect = '確認中';
          break;
        case '預約完成':
          if (vm.nowSelect === '預約完成') return;
          vm.nowSelect = '預約完成';
          break;
        case '已過期':
          if (vm.nowSelect === '已過期') return;
          vm.nowSelect = '已過期';
          break;
        default:
          break;
      }
    },
    cancelReservationHandler(reservationId) {
      console.log('取消預約', reservationId);
    },
    editReservationHandler(reservationId) {
      console.log('修改預約', reservationId);
      const vm = this;
      vm.$router.push({
        name: SM_RESERVATION_EDIT,
        params: {
          id: reservationId
        }
      });
    },
    confirmReservationHandler(reservationId) {
      console.log('預約確認', reservationId);
    }
  },
  computed: {
    filterReservationList() {
      const vm = this;
      if (vm.nowSelect === '已預約') {
        return vm.reservationList.filter((reserve) => reserve.status === 0);
      } if (vm.nowSelect === '確認中') {
        return vm.reservationList.filter((reserve) => reserve.status === 1);
      } if (vm.nowSelect === '預約完成') {
        return vm.reservationList.filter((reserve) => reserve.status === 2);
      } if (vm.nowSelect === '已過期') {
        return vm.reservationList.filter((reserve) => reserve.status === 3);
      }
        return [];
    }
  }
};
</script>

<style>

</style>
